export const GET_TAGS = 'reports/GET_TAGS'
export const GET_TAGS_SUCCESSFUL = 'reports/GET_TAGS_SUCCESSFUL'
export const GET_TAGS_FAILURE = 'reports/GET_TAGS_FAILURE'

export const GET_TAG_OPTIONS = 'reports/GET_TAG_OPTIONS'
export const GET_TAG_OPTIONS_SUCCESSFUL = 'reports/GET_TAG_OPTIONS_SUCCESSFUL'
export const GET_TAG_OPTIONS_FAILURE = 'reports/GET_TAG_OPTIONS_FAILURE'
